import globals from './globals';
var DGS = window.DGS; // eslint-disable-line

var determineStepType = function determineStepType(viewType) {
  switch (viewType) {
    case globals.STEP_TYPE_BUTTON_RESPONSE:
    case globals.STEP_TYPE_SLIDER_RESPONSE:
      return globals.GTM_QUESTION;
    case globals.STEP_TYPE_ENVIRONMENT:
      return globals.GTM_ENVIRONMENT;
    case globals.STEP_TYPE_ENVIRONMENT_INTRO:
      return globals.GTM_ENVIRONMENT_INTRO;
    case globals.STEP_TYPE_TONE_CALIBRATION_INTRO:
    case globals.STEP_TYPE_TONE_CALIBRATION_PLAY_TEST_SOUND:
    case globals.STEP_TYPE_TONE_CALIBRATION_ADJUST_VOLUME:
      return globals.GTM_CALIBRATION;
    case globals.STEP_TYPE_TONE:
      return globals.GTM_TONE;
    case globals.STEP_TYPE_TONE_START:
      return globals.GTM_TONE_START;
    case globals.STEP_TYPE_TONE_DONE:
      return globals.GTM_TONE_DONE;
    default:
      return false;
  }
};
var gtmStepTypeCounter = 1;
var gtmStepCounter = 0;
var gtmViewType = '';
var currentViewID = null;
var viewSubCounter = 1;
var determineIncrement = function determineIncrement(gtmType) {
  return gtmType !== globals.GTM_TONE && gtmType !== globals.GTM_ENVIRONMENT;
};
var determineStepCountInit = function determineStepCountInit(gtmType) {
  return gtmType === globals.GTM_ENVIRONMENT_INTRO ? 0 : 1;
};
window.DGS.Event.getInstance().on('trackHearingTestNextStep', function (viewType, viewID) {
  if (typeof dataLayer !== 'undefined') {
    var stepType = determineStepType(viewType);
    if (stepType) {
      gtmStepCounter += 1;
      if (viewID) {
        if (viewID !== currentViewID) {
          viewSubCounter += 1;
          gtmStepCounter = 1;
        }
        currentViewID = viewID;
      }
      if (determineIncrement(stepType)) {
        if (stepType !== gtmViewType && gtmViewType !== '') {
          gtmStepTypeCounter += 1;
          gtmStepCounter = determineStepCountInit(stepType);
          viewSubCounter = 1;
        }
      }
      gtmViewType = stepType;
      var payload = {
        event: globals.GTM_EVENT,
        eventCategory: globals.GTM_CATEGORY,
        eventAction: "".concat(globals.GTM_ACTION, " 0").concat(gtmStepTypeCounter).concat(gtmStepCounter > 0 ? "-".concat(gtmStepCounter) : ''),
        eventLabel: stepType.replace('[count]', gtmStepCounter).replace('[subcount]', viewSubCounter)
      };
      DGS.GTMTracking.getDataLayer().push(payload);
    }
  } else {
    console.log('GTM not implemented.');
  }
});
window.DGS.Event.getInstance().on('trackHearingTestNextTone', function (progress) {
  if (typeof dataLayer !== 'undefined') {
    var payload = {
      event: globals.GTM_EVENT,
      eventCategory: globals.GTM_CATEGORY,
      eventAction: 'step 03-1-1',
      eventLabel: globals.GTM_TONE_DONE.replace('[percentage]', progress)
    };
    DGS.GTMTracking.getDataLayer().push(payload);
  } else {
    console.log('GTM not implemented.');
  }
});
window.DGS.Event.getInstance().on('trackHearingTestResult', function (score) {
  if (typeof dataLayer !== 'undefined') {
    gtmStepTypeCounter += 1;
    gtmStepCounter = 1;
    DGS.GTMTracking.getDataLayer().push({
      event: globals.GTM_EVENT,
      eventCategory: globals.GTM_CATEGORY,
      eventAction: "".concat(globals.GTM_ACTION, " 0").concat(gtmStepTypeCounter, "-").concat(gtmStepCounter),
      eventLabel: "".concat(globals.GTM_RESULT, " ").concat(score)
    });
  } else {
    console.log('GTM not implemented.');
  }
});